<template>
  <div class="popup-click-area" @click="clickPopup">
    <p class="popup-click-area__text">
      <slot />
    </p>
    <PopUpSVG v-if="showIcon" :fill-color="'#1370FF'" width="16px" height="16px" />
  </div>
</template>

<script>
import PopUpSVG from '@/components/icons/PopUpSVG'
export default {
  name: 'PopupClickArea',
  components: {
    PopUpSVG
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    clickPopup () {
      this.addPopupOpenClass()
      this.$emit('openPopup')
    },
    addPopupOpenClass () {
      const modalBG = document.createElement('div')
      modalBG.className = 'modal-bg'
      document.body.appendChild(modalBG)
      document.body.classList.add('popup-open')
    }
  }
}
</script>

<style lang="scss">
.modal-bg {
  position:absolute;
  width:100%;
  height:100%;
  opacity:0.3;
  z-index:9;
  background:#000;
}
</style>

<style scoped lang="scss">
  .popup-click-area {
  display:flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
  top: -17px;

  @media(min-width: 720px ) {
      justify-content: center;
  }

  &__text {
    font-size: 16px;
    letter-spacing: -0.64px;
    color: #1370FF;
    margin: 0 5px 0 0;
  }
}
</style>
